<template>
  <div class="graduate-wrapper">
    <div class="baseinfo">
      <div class="student">
        <div class="avatar"><img :src="studentData.avatar" alt=""></div>
        <div class="name">{{studentData.showname}}</div>
        <div class="awards">
          <div class="award-item" v-if="studentData.is_excellent == 1">
            <i class="award-icon graduate"></i>
          </div>
          <div class="award-item" v-if="studentData.is_newstar == 1">
            <i class="award-icon star"></i>
          </div>
        </div>
        <div class="school-info">{{studentData.school_from}} | {{studentData.school_major}}</div>
        <div class="grades">
          <p v-if="studentData.gpa">GPA: {{studentData.gpa}}</p>
          <p v-if="studentData.toefl">TOEFL: {{studentData.toefl}}</p>
          <p v-if="studentData.gre">GRE: {{studentData.gre}}</p>
          <p v-if="studentData.wes">WES: {{studentData.wes}}</p>
          <p v-if="studentData.ielts">IELTS : {{studentData.ielts}}</p>
          <p v-if="studentData.testdaf">TestDaF: {{studentData.testdaf}}</p>
          <p v-if="studentData.jlpt">JLPT: {{studentData.jlpt}}</p>
        </div>
        <div class="thanks-text" v-if="studentData.description">{{studentData.description}}</div>
      </div>
      <div class="article-link" v-if="studentData.article" @click="toArticle">
        <div class="title">{{studentData.article.title}}</div>
        <div class="link">去看经验弹<icon icon-class="arrow-right"></icon></div>
      </div>
    </div>
    <div class="offers">
      <div class="graduate-title">录取院校</div>
      <div class="offers-list">
        <div class="offer-item" v-for="(item, index) in studentData.offer">
          <div class="logo"><img :src="item.logo" alt=""></div>
          <div class="offer-info">
            <div class="school-name">{{item.name}}<span class="choose" v-if="index == 0">最终去向</span></div>
            <div class="project">项目: {{item.project}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="works">
      <div class="graduate-title">作品展示</div>
      <!-- 查看作品 -->
      <div class="portfolio" v-if="studentData.portfolio_after" @click="checkPdf">查看学生作品</div>
    </div>
    <div class="teachers">
      <div class="graduate-title">Ta的老师</div>
      <div class="teacher-text"></div>
      <div class="teacher-list">
        <div class="teacher-item" v-for="item in studentData.private">
          <div class="avatar"><img :src="item.avatar" alt=""></div>
          <div class="teacher-content">
            <div class="teacher-name">{{item.stagename}}</div>
            <div class="titles">
              <div class="title">{{item.title1}}</div>
              <div class="title">{{item.title2}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
  .graduate-wrapper{
    .graduate-title{
      position: relative;
      padding-left: 6px;
      font-size: 16px;
      line-height: 24px;
      color: #333;
      font-weight: 600;
      &::after{
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 2px;
        height: 16px;
        background: @cano;
      }
    }
    .baseinfo{
      background: #FFF;
      padding: 44px 16px 20px;
      .student{
        background: #F3F3F3;
        position: relative;
        padding: 1px 12px 15px;
        .avatar{
          margin-top: -22px;
          width: 44px;
          height: 44px;
          border: 2px solid #FFF;
          border-radius: 50%;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .name{
          margin-top: 12px;
          font-size: 14px;
          line-height: 14px;
          color: #333;
          font-weight: 600;
        }
        .awards{
          position: absolute;
          right: 8px;
          top: -4px;
          display: flex;
          justify-content: center;
          align-items: center;
          .award-icon{
            display: block;
            width: 40px;
            height: 44px;
            &.graduate{
              background: url('/Application/Home/Resource/static/images/achievement/graduate-badge-small.png') no-repeat center center;
              background-size: cover;
            }
            &.star{
              background: url('/Application/Home/Resource/static/images/achievement/scholarship-badge-small.png') no-repeat center center;
              background-size: cover;
            }
          }
        }
        .school-info{
          margin-top: 10px;
          font-size: 13px;
          line-height: 18px;
          color: #666;
        }
        .grades{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          p{
            padding: 0 4px;
            height: 20px;
            line-height: 20px;
            border: 1px solid #CCC;
            font-size: 12px;
            color: #666;
            margin: 4px 4px 0 0;
            white-space: nowrap;
            border-radius: 4px;
          }
        }
        .thanks-text{
          margin-top: 8px;
          padding-top: 8px;
          border-top: 1px solid #CCC;
          font-size: 13px;
          line-height: 20px;
          color: #666;
        }
      }
      .article-link{
        position: relative;
        margin-top: 16px;
        padding: 16px 12px;
        color: #FFF;
        background: url('/Application/Home/Resource/static/images/mobile/too-see-experience-card.png') no-repeat center center;
        background-size: cover;
        width: 100%;
        height: 1.02rem;
        .title{
          font-size: 15px;
          line-height: 24px;
          font-weight: 600;
        }
        .link{
          display: flex;
          align-items: center;
          position: absolute;
          bottom: 16px;
          right: 12px;
          font-size: 12px;
          line-height: 18px;
          svg{
            font-size: 12px;
            margin-left: 4px;
          }
        }
      }
    }
    .offers{
      border-top: 10px solid #F8F8F8;
      padding: 14px 16px 0;
      background: #FFF;
      .offers-list{
        .offer-item{
          padding: 16px 0;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #EEE;
          &:last-child{
            border-bottom: 0;
          }
          .logo{
            flex-shrink: 0;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .offer-info{
            padding-left: 12px;
            min-width: 0;
            .school-name{
              display: flex;
              align-items: center;
              font-size: 14px;
              line-height: 14px;
              color: #333;
              font-weight: bold;
              span{
                margin-left: 8px;
                padding: 0 4px;
                height: 20px;
                border-radius: 20px;
                background: rgba(62, 187, 159, 0.91);
                font-size: 12px;
                line-height: 20px;
                color: #FFF;
                font-weight: normal;
              }
            }
            .project{
              margin-top: 8px;
              font-size: 12px;
              line-height: 18px;
              color: #666;
            }
          }
        }
      }
    }
    .works{
      border-top: 10px solid #F8F8F8;
      padding: 14px 16px 0;
      background: #FFF;
      .portfolio{
        margin: 16px 0 20px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 44px;
        border: 1px solid @cano;
        font-size: 16px;
        color: @cano;
        border-radius: 44px;
      }
    }
    .teachers{
      border-top: 10px solid #F8F8F8;
      padding: 14px 16px 0;
      background: #FFF;
      .teacher-item{
        padding: 16px 0;
        display: flex;
        align-items: flex-start;
        border-bottom: 1px solid #EEE;
        &:last-child{
          border-bottom: 0;
        }
        .avatar{
          width: 48px;
          height: 48px;
          border-radius: 50%;
          flex-shrink: 0;
          overflow: hidden;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .teacher-content{
          padding-left: 12px;
          .teacher-name{
            font-size: 14px;
            line-height: 14px;
            margin-top: 2px;
            color: #333;
            font-weight: 600;
          }
          .titles{
            margin-top: 7px;
            font-size: 12px;
            line-height: 18px;
            color: #666;
          }
        }
      }
    }
  }
</style>

<script>
  export default {
    data() {
      return {
        studentData: {},
      }
    },
    created() {
      this.$root.post('/Star/get_newstar_detail', {
        id: this.$route.params.id
      }).then(data => {
        console.log(data);
        this.studentData = data;
      })
    },
    methods: {
      toArticle() {
        this.$router.push({name: 'ArticleDetail', params: {id: this.studentData.article.id}});
      },
      checkPdf() {
        window.open(this.studentData.portfolio_after);
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Star/graduateDetail.vue